import React from 'react';
import { useTranslation } from 'react-i18next';
import { BD, BD_BANNER_STRIPES } from '../bookDemoTheme';

interface OpportunityBannerProps {
  /** Pre-formatted savings range. Placeholder figures until the user approves real ones. */
  amount: string;
  /**
   * Tighter spacing for the revenue step, where the banner sits above the options list and every
   * pixel it takes is a pixel the list loses from the fixed viewport budget. The review screen
   * uses the full-size version.
   */
  compact?: boolean;
}

const OpportunityBanner: React.FC<OpportunityBannerProps> = ({ amount, compact = false }) => {
  const { t } = useTranslation();

  return (
    <div className={`relative overflow-hidden rounded-xl text-center ${compact ? 'p-3' : 'p-4'} ${BD.accentBgDeep}`}>
      <div
        className="pointer-events-none absolute inset-0"
        style={{ backgroundImage: BD_BANNER_STRIPES }}
        aria-hidden="true"
      />
      <div className="relative z-[1]">
        <p
          className={`font-medium uppercase ${BD.textOnAccent} ${
            compact ? 'text-[13px] leading-5 mb-2' : 'text-[16px] leading-6 mb-4'
          }`}
        >
          {t('bookDemo.opportunity.title')}
        </p>
        <p
          className={`font-bold ${BD.textOnAccent} ${
            compact ? 'text-[20px] sm:text-[26px] leading-7' : 'text-[22px] sm:text-[32px] leading-6 sm:leading-[29px]'
          }`}
        >
          {amount}
        </p>
        <p
          className={`font-medium ${BD.textOnAccentSoft} ${
            compact ? 'text-[13px] leading-5 mt-2' : 'text-[14px] sm:text-[16px] leading-5 sm:leading-6 mt-3.5 sm:mt-5'
          }`}
        >
          {t('bookDemo.opportunity.subtitle')}
        </p>
      </div>
    </div>
  );
};

export default OpportunityBanner;
